<template>
    <section>
        <v-layout row style="width: 90%;margin: auto;">
            <v-data-table :headers="headers" 
                          :items="GetReviews" 
                          item-key="Course_Title" 
                          class="elevation-1"
                          style="width:100%;margin-top:10px;">
                <template v-slot:headers="props">
                    <tr>
                        <th v-for="header in props.headers" :key="header.text">
                        {{ header.text }}
                        </th>
                    </tr>
                </template>
                <template v-slot:items="props">
                    <tr>
                        <td class="text-xs-center">{{ props.item.Course_Title }}</td>
                        <td class="text-xs-center">{{ props.item.Review_Message }}</td>
                        <td class="text-xs-center">
                            <star-rating v-bind:star-size="15" :rating='props.item.Review_Number' read-only></star-rating>
                        </td>
                        <td class="text-xs-center">{{ props.item.Review_Status ? 'Approved' : 'Not Approved' }}</td>
                        <td class="text-xs-center">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-if="!props.item.Review_Status" color="primary" class="clsForActions" dark v-on="on" @click="OpenApproveOrDecline(props.item,'Approve')">thumb_up</v-icon>
                                    <v-icon v-else color="red" class="clsForActions" dark v-on="on" @click="OpenApproveOrDecline(props.item,'Decline')">thumb_down</v-icon>
                                </template>
                                <span v-if="!props.item.Review_Status">Approve</span>
                                <span v-else>Decline</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon color="primary" class="clsForActions" dark v-on="on" @click="OpenUpdateProjectModal(props.item)">edit</v-icon>
                                </template>
                                <span>Update</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon color="error" class="clsForActions" dark v-on="on" @click="OpenDeleteReview(props.item)">delete</v-icon>
                                </template>
                                <span>Delete</span>
                            </v-tooltip>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-layout>
        <app-update-review ref='updateReview' :dialog='UpdateReview' @close='CloseDialog'></app-update-review>
    </section>
</template>

<script>
    import appUpdateReview from '../dialogs/UpdateCourseReview'

export default {
    components: {
        appUpdateReview
    },
    data(){

        return {

            headers                     : [ { text: 'Course Title',value: 'Course_Title' },
                                            { text: 'Review Message',value: 'Review_Message' },
                                            { text: 'Review Starts',value: 'Review_Number' },
                                            { text: 'Review Status', value: 'Review_Status'},
                                            { text: 'Update Actions' } ],
            UpdateReview               : false,
        }
    },
    computed:{
        GetReviews(){

            return this.$store.getters.GetReview
        }
    },
    methods:{
      OpenUpdateProjectModal(Review){

          this.UpdateReview  = true
          this.$refs.updateReview.SetReviewDetails(Review)
      },
      OpenApproveOrDecline(Course,Status){
    
        let data = {}
        data['Review_Id'] = Course['_id']
        data['Update'] = {}
        data['Update']['Review_Status'] = Status == 'Approve' ? true : false
        
        this.$http.post(`${this.$store.getters.GetProductionUrl}/coursereview/approvecoursereview`,data)
                    .then(response =>{
                        
                        this.$store.commit('UpdateIndividualReview',response["data"]["response"][0])

                    })
                    .catch(err =>{

                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                    })

      },
      OpenDeleteReview(data){
            if (confirm("Do you really want to delete?")) {

                this.$http.post(`${this.$store.getters.GetProductionUrl}/coursereview/deletecoursereview`,data)
                        .then(response =>{
                            
                            this.$store.commit('DeleteIndividualReview',response["data"]["response"])

                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                        })
            }
      },
      CloseDialog(){

          this.UpdateReview    = false
      }
    },
    mounted(){

        this.$eventHub.$emit("LOADING",'true')
        this.$http.post(`${this.$store.getters.GetProductionUrl}/coursereview/getcoursereviews`,{})
                    .then(response =>{
                        
                        this.$store.commit('SetReview',response["data"]["response"])
                        this.$eventHub.$emit("LOADING",'false')
    
                    })
                    .catch(err =>{

                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                    })
    }
}
</script>
<style scoped>
.clsForActions{

    margin: 2px;
    padding: 2px;
    border: 1px solid #0000003d;
    border-radius: 2px;
}
</style>


